import React, { useState, useEffect } from 'react';

import toast from 'react-hot-toast';

// reactstrap components
import {
  Card,
  CardHeader,
  Table,
  Container,
  Row,
  Button,
  Input,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Modal,
  CardBody,
  Form,
  Col,
} from 'reactstrap';
// core components
import Header from 'components/Headers/Header.js';

import {
  FaEdit,
  FaPlusCircle,
  FaTimesCircle,
  FaArrowCircleUp,
} from 'react-icons/fa';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import { arredondaDecimais } from 'utils/arredondaDecimais';

import Swal from 'sweetalert2';

import api from 'services/api';

import ClasseModel from '../../../models/ConfiguradorClasse';

const ConfiguradorClasse: React.FC = () => {
  const [classe, setClasse] = useState([] as ClasseModel[]);
  // eslint-disable-next-line prettier/prettier
  const [classeEditing, setClasseEditing] = useState({} as ClasseModel);

  const [formModalState, setFormModalState] = useState(false);

  const [mostrarInativos, setMostrarInativos] = useState(false);

  async function listaClasse() {
    const response = await api.get('/integracao/classe');

    setClasse(response.data);
  }

  useEffect(() => {
    sessionStorage.setItem('TelaConfig', '');
  }, []);

  useEffect(() => {
    listaClasse();
  }, []);

  async function handleAtiva(row: any) {
    if (!row.isNew) {
      Swal.fire({
        title: `Deseja reativar a classe?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `Sim`,
        confirmButtonColor: '#d33',
        cancelButtonText: `Não`,
      }).then(async result => {
        if (result.isConfirmed) {
          await api.put(`/integracao/classe/${row.id}`, {
            nome: row.nome,
            pressao: row.pressao,
            limite: row.limite,
            indicAtivo: 'S',
          });
          Swal.close();
          toast.success('Classe Reativada');
          listaClasse();
        }
      });
    } else {
      listaClasse();
    }
  }

  async function handleDesativa(row: any) {
    if (!row.isNew) {
      Swal.fire({
        title: `Deseja desativar a classe?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `Sim`,
        confirmButtonColor: '#d33',
        cancelButtonText: `Não`,
      }).then(async result => {
        if (result.isConfirmed) {
          await api.put(`/integracao/classe/${row.id}`, {
            nome: row.nome,
            pressao: row.pressao,
            limite: row.limite,
            indicAtivo: 'N',
          });
          Swal.close();
          toast.success('Classe desativada');
          listaClasse();
        }
      });
    } else {
      listaClasse();
    }
  }

  async function handleInsert() {
    setClasseEditing({} as ClasseModel);
    setFormModalState(!formModalState);
  }

  function handleUpdate(Classe: ClasseModel) {
    setClasseEditing(Classe);
    setFormModalState(!formModalState);
  }

  async function handleSaveClasse() {
    // eslint-disable-next-line prettier/prettier
    const { nome } = classeEditing;

    if (!nome) {
      toast.error(
        'Todos os campos marcados com * são de preenchimento obrigatório!',
      );
      return;
    }

    if (classeEditing.id) {
      await api.put(`/integracao/classe/${classeEditing.id}`, {
        nome: classeEditing.nome,
        pressao: classeEditing.pressao,
        limite: classeEditing.limite,
        indicAtivo: 'S',
      });
    } else {
      await api.post(`/integracao/classe`, {
        nome: classeEditing.nome,
        pressao: classeEditing.pressao,
        limite: classeEditing.limite,
        indicAtivo: 'S',
      });
    }

    toast.success('Registro concluído');
    setFormModalState(false);
    setClasseEditing({} as ClasseModel);
    listaClasse();
  }

  return (
    <>
      <Header showCards={false} />
      {/* Page content */}
      <Container className="mt--7" fluid>
        <Row>
          <Col>
            <FormGroup className="mb-4">
              <InputGroup>
                <Button
                  className="btn-icon btn-2"
                  color="primary"
                  type="button"
                  onClick={handleInsert}
                >
                  <FaPlusCircle />
                </Button>
              </InputGroup>
            </FormGroup>
          </Col>
        </Row>

        {/* Table */}
        <Row>
          <div className="col">
            {/* Modal edição */}
            <Modal
              className="modal-dialog-centered"
              size="sm"
              isOpen={formModalState}
              toggle={() => setFormModalState(!formModalState)}
            >
              <div className="modal-body p-0">
                <Card className="bg-secondary shadow border-0">
                  <CardBody className="px-lg-5 py-lg-5">
                    <div className="text-center text-muted mb-4">
                      <small>Classe {classeEditing.nome}</small>
                    </div>
                    <Form role="form">
                      <FormGroup className="mb-3">
                        <small>Nome*</small>
                        <InputGroup className="input-group-alternative">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-tag" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            placeholder="Nome"
                            value={classeEditing.nome}
                            type="text"
                            onChange={text =>
                              setClasseEditing({
                                ...classeEditing,
                                nome: text.target.value,
                              })
                            }
                          />
                        </InputGroup>
                      </FormGroup>
                      <FormGroup className="mb-3">
                        <small>Pressão </small>
                        <InputGroup className="input-group-alternative">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-tag" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            placeholder="Pressão"
                            value={classeEditing.pressao}
                            type="number"
                            onChange={text =>
                              setClasseEditing({
                                ...classeEditing,
                                pressao: Number(text.target.value),
                              })
                            }
                          />
                        </InputGroup>
                      </FormGroup>
                      <FormGroup className="mb-3">
                        <small>Limite </small>
                        <InputGroup className="input-group-alternative">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-tag" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            placeholder="Limite"
                            value={classeEditing.limite}
                            type="number"
                            onChange={text =>
                              setClasseEditing({
                                ...classeEditing,
                                limite: Number(text.target.value),
                              })
                            }
                          />
                        </InputGroup>
                      </FormGroup>
                      <div className="text-center">
                        <Button
                          className="my-4"
                          color="primary"
                          type="button"
                          onClick={handleSaveClasse}
                        >
                          Salvar
                        </Button>
                      </div>
                    </Form>
                  </CardBody>
                </Card>
              </div>
            </Modal>

            <Card className="shadow">
              <CardHeader className="border-0">
                <h3 className="mb-0">Lista de Classes</h3>
              </CardHeader>
              <Row>
                <Col sm="9" />
                <Col sm="3">
                  <FormControlLabel
                    className="float-right"
                    control={
                      <Checkbox
                        checked={mostrarInativos}
                        onChange={event =>
                          setMostrarInativos(event.target.checked)
                        }
                        color="primary"
                      />
                    }
                    label="Mostrar Inativos"
                  />
                </Col>
              </Row>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th>Nome</th>
                    <th>Pressão</th>
                    <th>Limite</th>
                    <th>&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  {classe
                    .filter(item =>
                      !mostrarInativos ? item.indicAtivo === 'S' : item,
                    )
                    .map(filteredClasse => (
                      <tr key={filteredClasse.id}>
                        <td
                          className={
                            filteredClasse.indicAtivo === 'S'
                              ? 'py-1'
                              : 'text-muted'
                          }
                        >
                          <strong>{filteredClasse.nome}</strong>
                        </td>
                        <td
                          className={
                            filteredClasse.indicAtivo === 'S'
                              ? 'py-1'
                              : 'text-muted'
                          }
                        >
                          <strong>
                            {arredondaDecimais(filteredClasse.pressao, 2)}
                          </strong>
                        </td>
                        <td
                          className={
                            filteredClasse.indicAtivo === 'S'
                              ? 'py-1'
                              : 'text-muted'
                          }
                        >
                          <strong>
                            {arredondaDecimais(filteredClasse.limite, 2)}
                          </strong>
                        </td>
                        <td
                          className={
                            filteredClasse.indicAtivo === 'S'
                              ? 'py-1'
                              : 'text-muted'
                          }
                        >
                          {filteredClasse.indicAtivo === 'S' ? (
                            <Button
                              size="sm"
                              className="btn-icon"
                              color="warning"
                              type="button"
                              onClick={() => {
                                handleUpdate(filteredClasse);
                              }}
                            >
                              <FaEdit />
                            </Button>
                          ) : (
                            <Button
                              size="sm"
                              className="btn-icon"
                              color="default"
                              type="button"
                              onClick={() => {
                                handleAtiva(filteredClasse);
                              }}
                            >
                              <FaArrowCircleUp />
                            </Button>
                          )}
                          {filteredClasse.indicAtivo === 'S' ? (
                            <Button
                              size="sm"
                              className="btn-icon"
                              color="danger"
                              type="button"
                              onClick={() => {
                                handleDesativa(filteredClasse);
                              }}
                            >
                              <FaTimesCircle />
                            </Button>
                          ) : null}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default ConfiguradorClasse;
